@if (iconUrl()) {
  <img alt="" width="64" height="64" class="app-icon" [src]="iconUrl()" />
} @else if (iconClass()) {
  <si-icon class="app-icon" [icon]="iconClass()!" />
}
<div class="app-text">
  <div class="si-h4 d-flex align-items-center mw-100 gap-1">
    <span class="text-truncate">
      <ng-content select="[app-name]" />
    </span>
    @if (external()) {
      <si-icon
        class="icon"
        [icon]="icons.elementExport"
        [attr.aria-label]="externalLinkText() | translate"
      />
    }
  </div>
  <div class="si-body text-secondary mt-2 text-truncate mw-100">
    <ng-content select="[app-systemName]" />
  </div>
</div>
@if (enableFavoriteToggle()) {
  <si-icon
    class="icon favorite-icon"
    [class.is-favorite]="favorite()"
    [icon]="favorite() ? icons.elementFavoritesFilled : icons.elementFavorites"
    (click)="favoriteClicked($event)"
  />
}
